import { useEffect, useState, useContext } from 'react';

import { AppContext } from '../scripts/context'

export default function Widget() {            
            
    const {
    //WIDGET
        widgetState,
        setWidgetState,
        getWidgetWidthCorr,
    //SCROLL
        getScrollSection,
    //STYLE
        widgetContainerStyleState,
        widgetStyleState
    } = useContext(AppContext);

    const [widgetButtonFillState, setWidgetButtonFillState] = useState("#00000066");
    const [widgetWidthCorrState, setWidgetWidthCorrState] = useState(getWidgetWidthCorr());

	const android_app_icon = {
		svg:

        <svg version="1.1" id="android_app_icon_svg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 66 66" preserveAspectRatio="xMidYMid meet" pointerEvents="none">

            <circle fill="#333333" cx="33" cy="33" r="32.9"/>
	        <path fill="#FFFFFF" d="M0,33c0,0.563,0.015,1.122,0.042,1.679l31.279,31.278C31.877,65.985,32.437,66,33,66c0.915,0,1.819-0.047,2.716-0.12L0.121,30.283C0.047,31.18,0,32.084,0,33z"/>
	        <path fill="#FFFF00" d="M2.346,20.783l42.871,42.872c1.049-0.419,2.072-0.889,3.065-1.409L3.753,17.718C3.234,18.711,2.764,19.734,2.346,20.783z"/>
	        <path fill="#CCFF33" d="M8.574,10.811l46.616,46.615c0.781-0.709,1.527-1.455,2.236-2.236L10.811,8.574C10.03,9.283,9.283,10.03,8.574,10.811z"/>
	        <path fill="#00CCFF" d="M17.718,3.753l44.528,44.529c0.521-0.993,0.99-2.017,1.409-3.065L20.783,2.346C19.734,2.764,18.711,3.234,17.718,3.753z"/>
	        <path fill="#FFFFFF" d="M33,0c-0.916,0-1.82,0.047-2.718,0.121L65.88,35.718C65.953,34.821,66,33.916,66,33c0-0.564-0.015-1.124-0.043-1.681L34.681,0.042C34.124,0.015,33.563,0,33,0z"/>

        </svg>

	};

    function getWidgetBgOpacity() {

        let scrollSection = getScrollSection();
        let opacity = "0.85";

        if (scrollSection === "topEnd" || scrollSection === "bottomEnd") {

            opacity = "0.75";

        };

        return opacity

    };

    function handleResize() {

        setWidgetWidthCorrState(getWidgetWidthCorr());

    };

    //useEffect on initial render
    useEffect(() => {

        window.addEventListener("resize", handleResize);

        return () => {

            window.removeEventListener("resize", handleResize);

        };
                                                                                                                                                // eslint-disable-next-line
    }, []);

    return (
        <div id="widget_container" style={widgetContainerStyleState}>
            {widgetState !== false ? 
                <div id="widget" style={widgetStyleState}>
                    <div id="widget_content" style={{width: (480 - widgetWidthCorrState * 2) + "px"}}>
                        <svg version="1.1" id="widget_svg" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 480 192" preserveAspectRatio="xMinYMin meet" pointerEvents="none">
                            <path id="widget_bg" fill="#000000" opacity={getWidgetBgOpacity()} d={"M" + (417.574 - widgetWidthCorrState) + ",192c3.85,0,8.575-2.728,10.5-6.063l48.426-83.875C" + (478.425 - widgetWidthCorrState) + ",98.728," + (480 - widgetWidthCorrState) + ",92.85," + (480 - widgetWidthCorrState) + ",89V7c0-3.85-3.15-7-7-7H" + (62.426 + widgetWidthCorrState) + "c-3.85,0-8.575,2.728-10.5,6.062L" + (3.5 + widgetWidthCorrState) + ",89.938C" + (1.575 + widgetWidthCorrState) + ",93.272," + (0 + widgetWidthCorrState) + ",99.15," + (0 + widgetWidthCorrState) + ",103v82c0,3.85,3.15,7,7,7H" + (417.574 - widgetWidthCorrState) + "z"} pointerEvents="auto"/>
                            <g transform={"translate(-" + widgetWidthCorrState + " 0)"}>
                                <rect id="widget_close_bg" x="444" fill="#000000" opacity="0" width="36" height="36" pointerEvents="auto" onClick={() => {setWidgetState(false)}}/>
                                <polygon id="widget_close_icon" fill="#FFFFFF" points="456.938,24.75 462,19.688 467.063,24.75 468.75,23.063 463.688,18 468.75,12.938 467.063,11.25 462,16.313 456.938,11.25 455.25,12.938 460.313,18 455.25,23.063 " pointerEvents="none"/>
                            </g>
                        </svg>
                        {(() => {
                            if (widgetState === "android") {
                                return (
                                    <div id="widget_text">
                                        <div id="widget_text_title">njb.design app</div>
                                        <div id="widget_app_container">
                                            {android_app_icon.svg}
                                            <div id="widget_text_external_url">explore njb.design and get notifications</div>
                                        </div>
                                        <div id="widget_button_container">
                                            <a      id="widget_button"
                                                    href={"https://play.google.com/store/apps/details?id=njb.design"}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{backgroundColor: widgetButtonFillState}}
                                                    onClick={() => {setWidgetState(false)}}
                                                    onPointerDown={() => {setWidgetButtonFillState("#66666666")}}
                                                    onTouchStart={() => {setWidgetButtonFillState("#66666666")}}
                                                    onPointerUp={() => {setWidgetButtonFillState("#00000066")}}
                                                    onPointerLeave={() => {setWidgetButtonFillState("#00000066")}}
                                                    onTouchEnd={() => {setWidgetButtonFillState("#00000066")}}
                                            >
                                                <div id="widget_text_button">open google play</div>
                                            </a>
                                        </div>
                                    </div>
                                )
                            } else if (widgetState === "ios") {
                                return (
                                    <div id="widget_text">
                                        <div id="widget_text_title">njb.design app</div>
                                        <div id="widget_app_container">
                                            {android_app_icon.svg}
                                            <div id="widget_text_external_url">explore njb.design and get notifications</div>
                                        </div>
                                        <div id="widget_button_container">
                                            <a      id="widget_button"
                                                    href={"https://"}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{backgroundColor: widgetButtonFillState}}
                                                    onClick={() => {setWidgetState(false)}}
                                                    onPointerDown={() => {setWidgetButtonFillState("#66666666")}}
                                                    onTouchStart={() => {setWidgetButtonFillState("#66666666")}}
                                                    onPointerUp={() => {setWidgetButtonFillState("#00000066")}}
                                                    onPointerLeave={() => {setWidgetButtonFillState("#00000066")}}
                                                    onTouchEnd={() => {setWidgetButtonFillState("#00000066")}}
                                            >
                                                <div id="widget_text_button">open app store</div>
                                            </a>
                                        </div>
                                    </div>
                                )
                            } else if (widgetState.includes("https://")) {
                                return (
                                    <div id="widget_text">
                                        {(() => {
                                            if (widgetState.includes("steampowered.com") || widgetState.includes("steamcommunity.com")) {
                                                return (<div id="widget_text_title">get it on steam</div>)
                                            } else if (widgetState.includes("discord.com")) {
                                                return (<div id="widget_text_title">join on discord</div>)
                                            } else if (widgetState.includes("paypal.com")) {
                                                return (<div id="widget_text_title">donate via paypal</div>)
                                            } else if (widgetState.includes("xthrust.com")) {
                                                return (<div id="widget_text_title">get xthrust</div>)
                                            } else if (widgetState.includes("manuals")) {
                                                return (<div id="widget_text_title">download manual</div>)
                                            } else {
                                                return (<div id="widget_text_title">open external url</div>)
                                            }
                                        })()}
                                        <div id="widget_text_external_url">{widgetState.includes("manuals") ? <>{widgetState.slice(0, 33)}<br />{widgetState.slice(33)}</> : widgetState}</div>
                                        <div id="widget_button_container">
                                            <a      id="widget_button"
                                                    href={widgetState}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{backgroundColor: widgetButtonFillState}}
                                                    onClick={() => {setWidgetState(false)}}
                                                    onPointerDown={() => {setWidgetButtonFillState("#66666666")}}
                                                    onTouchStart={() => {setWidgetButtonFillState("#66666666")}}
                                                    onPointerUp={() => {setWidgetButtonFillState("#00000066")}}
                                                    onPointerLeave={() => {setWidgetButtonFillState("#00000066")}}
                                                    onTouchEnd={() => {setWidgetButtonFillState("#00000066")}}
                                            >
                                                <div id="widget_text_button">open url</div>
                                            </a>
                                        </div>
                                    </div>
                                )
                            }
                        })()}
                    </div>
                </div>
            : null}
        </div>
    );

};